import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ScrollFadeWrapper } from "@/components/ui/scroll-fade-wrapper";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { clinicalData } from "@/data/peptide-clinical-data";

const PeptideReference = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl text-foreground mb-1">Peptide Clinical Reference</h2>
        <p className="text-sm text-muted-foreground">
          Quick-reference guide — mechanism of action and primary indications for treatment selection.
        </p>
      </div>

      <Tabs defaultValue="weight">
        <ScrollFadeWrapper fadeColor="from-secondary">
        <TabsList className="flex overflow-x-auto no-scrollbar h-auto gap-1 bg-secondary p-1.5 w-full justify-start">
          {clinicalData.map((cat) => (
            <TabsTrigger key={cat.id} value={cat.id} className="gap-1.5 text-xs shrink-0">
              <cat.icon size={14} /> {cat.shortLabel}
            </TabsTrigger>
          ))}
        </TabsList>
        </ScrollFadeWrapper>

        {clinicalData.map((cat) => (
          <TabsContent key={cat.id} value={cat.id} className="mt-4">
            <Card className="border-border">
              <CardHeader className="pb-2">
                <CardTitle className="font-display text-lg">{cat.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead className="w-[180px]">Peptide</TableHead>
                      <TableHead>Mechanism of Action</TableHead>
                      <TableHead className="w-[250px]">Primary Indications</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {cat.peptides.map((p) => (
                      <TableRow key={p.name}>
                        <TableCell className="font-medium text-foreground">{p.name}</TableCell>
                        <TableCell className="text-sm text-muted-foreground">{p.mechanism}</TableCell>
                        <TableCell>
                          <div className="flex flex-wrap gap-1">
                            {p.indications.split(", ").map((ind) => (
                              <Badge key={ind} variant="secondary" className="text-xs font-normal">
                                {ind.replace(".", "")}
                              </Badge>
                            ))}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </TabsContent>
        ))}
      </Tabs>

      {/* Safety notes */}
      <Card className="border-border bg-secondary/30">
        <CardContent className="p-6">
          <h3 className="font-display text-lg text-foreground mb-3">Clinical Considerations</h3>
          <div className="grid md:grid-cols-3 gap-4 text-sm">
            <div>
              <p className="font-semibold text-foreground mb-1">Contraindications</p>
              <ul className="text-muted-foreground space-y-1">
                <li>• Active cancer (growth-stimulating peptides)</li>
                <li>• Pregnancy & breastfeeding</li>
                <li>• Severe renal/liver impairment</li>
              </ul>
            </div>
            <div>
              <p className="font-semibold text-foreground mb-1">Administration Routes</p>
              <ul className="text-muted-foreground space-y-1">
                <li>• Subcutaneous (most common)</li>
                <li>• Oral/Sublingual (BPC-157, MK-677)</li>
                <li>• Intranasal (Semax, Selank)</li>
                <li>• Topical (aesthetics)</li>
              </ul>
            </div>
            <div>
              <p className="font-semibold text-foreground mb-1">Side Effects</p>
              <ul className="text-muted-foreground space-y-1">
                <li>• Generally well-tolerated</li>
                <li>• Localized injection site reactions</li>
                <li>• Transient nausea, flushing, headache</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PeptideReference;
